export default "__VITE_ASSET__UEObpsNw__"